import Immutable from 'immutable';

const SuggestionsRecord = Immutable.Record({
  teacherId: undefined,
  overallSuggestion: undefined,
  overallRecommendation: undefined,
  suggestedTime: undefined,
  participationId: undefined,
  skillSuggestions: undefined,
});

export default class Suggestions extends SuggestionsRecord {}



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/Suggestions/model.js